import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Pagination, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {MyClaimDocumentContainerModel, ReguestByGuidContainer} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MyClaimDocumentService extends BaseApiTemplateService<MyClaimDocumentContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX
    + Core2Config.CLAIMS_PREFIX + 'documents/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX
      + Core2Config.CLAIMS_PREFIX + 'documents/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX
      + Core2Config.CLAIMS_PREFIX + 'documents/backoffice-ep';
    this.httpClient = http;
  }

  public getByCriteriaLoginEntityEp(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<MyClaimDocumentContainerModel>> {
    const url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX
      + Core2Config.CLAIMS_PREFIX + 'documents/login-entity-ep';
    let epURL = Core2Config.DOMAIN_URL + url;
    if (visa.api_domain_url) {
      epURL = visa.api_domain_url + url;
    }
    const UrlByCriteria = epURL + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MyClaimDocumentContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getByMultipleGuids(guids: ReguestByGuidContainer, visa: ApiVisa): Observable<PagingResponseModel<MyClaimDocumentContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'documents/backoffice-ep/query';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'documents/backoffice-ep/query';
    }
    return this.httpClient.post<PagingResponseModel<MyClaimDocumentContainerModel>>(url, guids, this.getHttpHeader(visa));
  }
}
